export default __webpack_public_path__ + "static/media/Testing-HD.46969d5e.jpg";